module.exports = __webpack_public_path__ + "img/login-left.4320f03e.png";